import { combineReducers } from 'redux'

import { termsAndConditionsOpen } from './termsAndConditionsReducer'
import { gamesLegalLines } from './gamesLegalLinesReducer'
import { updateBingoLobbyFeed } from './bingoLobbyFeedReducer'
import { updateStateModal } from './stateModalReducer'

export default combineReducers({
  termsAndConditionsOpen,
  gamesLegalLines,
  updateBingoLobbyFeed,
  updateStateModal
})
